import { cart } from 'src/common/assets/i18n-assets/de/cart';
import { common } from 'src/common/assets/i18n-assets/de/common';
import { habaAddress } from 'src/common/assets/i18n-assets/de/habaAddress';
import { habaCart } from 'src/common/assets/i18n-assets/de/habaCart';
import { habaCatalogForm } from 'src/common/assets/i18n-assets/de/habaCatalogForm';
import { habaContactForm } from 'src/common/assets/i18n-assets/de/habaContactForm';
import { habaCheckout } from 'src/common/assets/i18n-assets/de/habaCheckout';
import { habaCommon } from 'src/common/assets/i18n-assets/de/habaCommon';
import { habaCountries } from 'src/common/assets/i18n-assets/de/habaCountries';
import { habaMyAccountNavigation } from 'src/common/assets/i18n-assets/de/habaMyAccountNavigation';
import { habaProduct } from 'src/common/assets/i18n-assets/de/habaProduct';
import { habaUser } from 'src/common/assets/i18n-assets/de/habaUser';
import { habaWishlist } from 'src/common/assets/i18n-assets/de/habaWishlist';
import { userProfile } from 'src/common/assets/i18n-assets/de/userProfile';
import { product } from 'src/common/assets/i18n-assets/de/product';
import { newsletter } from 'src/common/assets/i18n-assets/de/newsletter';
import { returns } from 'src/common/assets/i18n-assets/de/returns';
import { seo } from 'src/common/assets/i18n-assets/de/seo';
import { address } from 'src/common/assets/i18n-assets/de/address';
import { cookiePage } from 'src/common/assets/i18n-assets/de/cookiePage';
import { habaAltText } from '../../../../common/assets/i18n-assets/de/alt-text';

export const deTranslationsHaba = {
  cart,
  common,
  cookiePage,
  address,
  habaAddress,
  habaCart,
  habaCatalogForm,
  habaContactForm,
  habaCheckout,
  habaCommon,
  habaCountries,
  habaMyAccountNavigation,
  habaProduct,
  habaUser,
  habaWishlist,
  userProfile,
  product,
  newsletter,
  seo,
  habaAltText,
  returns,
};
